import FiltersSelected from './FiltersSelected';

export default FiltersSelected;
